export const GEOLOCATION_FETCH = 'GEOLOCATION_FETCH'

export function fetchGeolocation() {
  return (dispatch) => {
    fetch('https://занять-денег.онлайн/api/v1/geolocation')
    .then(r => r.json())
    .then(info => dispatch({type: GEOLOCATION_FETCH, info}))
  }
}
